import EcwidProfileApi from '../api/EcwidProfileApi';
import {
  isSelectRendered,
  renderSelect,
  hideSelect,
} from './components/currencySelect';
import ConfigManager from './configManager';
import { convertPage } from './convertPage';
import { getTargetCurrency } from './targetCurrency';

const ECWID_CONVERTER_CLASS = 'ec-has-currency-converter';

const prepare = async (storeId, publicToken, appConfig) => {
  document.body.classList.add(ECWID_CONVERTER_CLASS);

  const storeProfile = await EcwidProfileApi.show(storeId, {
    token: publicToken,
  });

  const targetCurrency = await getTargetCurrency(
    appConfig,
    storeProfile,
    publicToken
  );

  ConfigManager.setConfig({ appConfig, storeProfile });
  ConfigManager.setTargetCurrency(targetCurrency);
};

const activate = (page) => {
  const config = ConfigManager.getConfig();

  if (!config.appConfig.isCurrencySelectEnabled) {
    hideSelect();
  }

  const isNeededRenderSelect =
    config.appConfig.isCurrencySelectEnabled && !isSelectRendered();
  if (isNeededRenderSelect) {
    const userCurrencies = config.appConfig.currencies;
    const optionCurrencies = [...userCurrencies, config.baseCurrency];

    const handleChangeTargetCurrency = (currency) => {
      ConfigManager.setTargetCurrency(currency);
    };

    renderSelect(
      config.targetCurrency,
      optionCurrencies,
      handleChangeTargetCurrency
    );
  }

  convertPage(page.type, config);
};

const deactivate = (page) => {
  hideSelect();
  if (!page) {
    return;
  }
  const config = ConfigManager.getConfig();
  const cleanUpConfig = { ...config, targetCurrency: config.baseCurrency };
  convertPage(page.type, cleanUpConfig);
};

export default { prepare, activate, deactivate };
